import React, { useState, useRef } from "react";
import { Button, Modal, Form, Input, Avatar, message } from "antd";
import { showMessage } from "utils";
import { CodeButton, CodeNewButton, phoneReg } from "components/common";
import cookies from "js-cookie";
import * as qs from "query-string";
import CommonIcon from "pages/components/commonIcon";
import axiosSig from "axios";
import { formItemLayout } from "../../../login/layout";

const { axios } = window;
const AlertFn = ({ visible, onClose, user, openAlertBol, infoAlertIsEdit }) => {
  const { companyid, forwardUrl } = qs.parse(window.location.search);
  const [sendCode, setSendCode] = useState(false);
  const [phone, setPhone] = useState(null);
  const [form] = Form.useForm();
  const [goTimer, setGoTimer] = useState(false);
  const appkey = "FFFF0N0000000000B190";
  const scene = "ic_other";
  const usernameRef = useRef("");
  // 获取短信验证码
  const getShortMsg = ({
    appkey,
    scene,
    sessionId,
    sig,
    token,
    mobile,
    codeType
  }) => {
    axiosSig
      .get("/api/alibaba/verificationCode", {
        params: {
          appkey,
          scene,
          mobile,
          sessionId,
          sig,
          token,
          codeType
        }
      })
      .then(res => {
        if (res.data.success) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }
      });
  };

  function setError(k, msg) {
    form.setFields([
      {
        name: k,
        value: form.getFieldValue(k),
        errors: [msg],
        touched: true
      }
    ]);
  }
  const validatePhone = (rule, value) => {
    if (phoneReg.test(value)) {
      setSendCode(true);
      setPhone(value);
      usernameRef.current = value;
      return Promise.resolve();
    }
    setSendCode(false);
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject("手机号码格式错误");
  };
  const onHrefs = () => {
    // alert(forwardUrl);
    if (forwardUrl) {
      if (forwardUrl) {
        if (forwardUrl) {
          const url = `${forwardUrl}${
            forwardUrl.indexOf("?") !== -1 ? "&" : "?"
          }token=${cookies.get("shorcuts")}`;
          // alert(url);
          window.location.href = url;
        }
      }
    } else {
      onClose();
    }
  };
  function bindingWxFn(params) {
    axios
      .post(`/customer/bindingPhoneNumber?force=${params.force}`, params)
      .then(({ status, data }) => {
        // console.log('handleSubmit', status, data)
        if (!data.success) {
          if (data.message.indexOf("该手机账号被别人使用") !== -1) {
            onClose();
            openAlertBol();
            sessionStorage.setItem("bindingData", JSON.stringify(params));
          } else {
            showMessage("error", data.message);
          }
          return;
        }
        console.log(
          "forwardUrl:",
          forwardUrl,
          "token:",
          cookies.get("shorcuts")
        );
        showMessage("success", "绑定成功！");
        // 成功后跳转
        onHrefs();
        user.dispatch({ type: "init" });
        // 关闭弹窗
        onClose();
      });
  }
  const onSubmit = values => {
    values.force = false;
    bindingWxFn(values);
  };
  return (
    <Modal
      title=""
      onCancel={infoAlertIsEdit ? onClose : null}
      visible={visible}
      footer={false}
      maskClosable={false}
    >
      <div className="textAlign">
        <CommonIcon
          self={user.self}
          ys={{
            width: 64,
            height: 64,
            lineHeight: "64px"
          }}
          ys2={{ fontSize: 12 }}
        />
        <p style={{ marginTop: 20 }}>{user.self.weixinNickName || ""}</p>
        <p>
          根据国家相关法律要求，使用互联网等服务，需要提供真实身份信息。请设置手机号以继续使用本服务
        </p>
      </div>
      <Form {...formItemLayout} onFinish={onSubmit}>
        <Form.Item
          label="手机号"
          name="username"
          validateFirst
          rules={[
            {
              required: true,
              message: "请输入您的手机号码"
            },
            {
              validator: validatePhone
            }
          ]}
        >
          <Input
            placeholder="请输入11位手机号"
            suffix={
              <CodeNewButton
                send={sendCode}
                username={phone}
                codeType={3}
                callbackhandleSc={data => {
                  // form.validateFields(["phone"]).then(value => {
                  const userName = usernameRef.current;
                  if (/^\d{11}$/.test(userName)) {
                    console.log("data", data);
                    setGoTimer(true);
                    getShortMsg({
                      appkey,
                      scene,
                      ...data,
                      mobile: userName,
                      codeType: 3,
                      sigToken: data.toekn
                    });
                  } else {
                    message.error("请输入正确的手机号码！");
                  }
                  // });
                  // getShortMsg({})
                }}
                callbackhandleSend={visible => {
                  // 验证成功后将 获取验证码按钮禁用
                  setGoTimer(false);
                }}
                goTimer={goTimer}
                renderTo="BindAlertCodeSc"
              />
            }
            // suffix={
            //   <CodeButton
            //     send={sendCode}
            //     username={phone}
            //     errorCallback={setError.bind(null, "code")}
            //     codeType={3}
            //   />
            // }
          />
        </Form.Item>
        <div id="BindAlertCodeSc" />
        <Form.Item
          label="验证码"
          name="code"
          validateFirst
          rules={[
            {
              required: true,
              message: "请输入验证码"
            },
            {
              pattern: /^\d{4}$/,
              message: "验证码格式错误"
            }
          ]}
        >
          <Input placeholder="请输入验证码" />
        </Form.Item>
        <Form.Item
          label="密码"
          name="password"
          rules={[
            {
              required: true,
              message: "请输入您的密码"
            },
            {
              pattern: /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,30}$/,
              // pattern: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{6,16}$/,
              message: "密码长度6-30位，至少包含数字、字母、特殊符号"
            }
          ]}
        >
          <Input.Password placeholder="请输入密码" />
        </Form.Item>
        <Form.Item
          {...formItemLayout}
          className="btns"
          style={{ textAlign: "right", marginTop: 30 }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", marginBottom: 10 }}
          >
            立即绑定
          </Button>
          {!cookies.get("dingzhiBol") && (
            <p style={{ textAlign: "center" }}>
              绑定即表示同意调研工厂
              <a href="/userPolicy" target="_blank">
                用户使用协议
              </a>
            </p>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AlertFn;
